import { getIn } from '../../../common/utils/getIn';
import { hasValidationError } from '../../../common/utils/hasValidationError';
import { setIn } from '../../../common/utils/setIn';
import { checkRequiredAllowZero, checkPositiveOrZeroNumber, checkPhone } from '../../../common/utils/validation';

const detailsValidationErrors = ({ booking }) => {
    const validationErrors = (() => {
        const errors = {};

        const setError = (fields, checks) => {
            fields.forEach((field) => {
                setIn(errors, field, checks.map((check) => check(getIn(booking, field))).find(Boolean) || false);
            });
        };

        const requiredFields = ['transfers.0.extras.HL', 'transfers.0.extras.ADD'];
        
        // Add validation for second transfer if it exists
        if (getIn(booking, 'transfers.1')) {
            requiredFields.push('transfers.1.extras.HL', 'transfers.1.extras.ADD');
        }

        setError(requiredFields, [checkRequiredAllowZero, checkPositiveOrZeroNumber]);

        // passengerPhone (optional, format-only) is entered on THIS step via
        // DifferentPassenger — validating it here lets the always-enabled continue
        // button highlight it; the payment step renders no control for it.
        setError(['passengerPhone'], [checkPhone]);

        return errors;
    })();

    const isValid = !hasValidationError(validationErrors);

    return isValid ? null : validationErrors;
};

export { detailsValidationErrors };
